import { VariantConfirmation } from '../types';

export interface ConfirmationDraft {
  id: number;
  confirmation: VariantConfirmation;
  method: string;
  vendor: string;
  use_double_dna: boolean;
  is_cnv: boolean;
  gene: string;
  needs_new_primers: boolean | null;
}

export function buildRequestConfirmationDraft(
  confirmation: VariantConfirmation
): ConfirmationDraft {
  return {
    id: confirmation.id,
    confirmation,
    method: confirmation.method,
    vendor: confirmation.vendor,
    use_double_dna: confirmation.use_double_dna,
    is_cnv: confirmation.variant.is_cnv,
    gene: confirmation.variant.gene,
    needs_new_primers: confirmation.needs_new_primers,
  };
}
